<template>
  <ValidationObserver ref="observer">
    <v-row no-gutters>
      <v-col>
        <validation-provider v-slot="{ errors }" :rules="validateRules">
          <v-text-field
            :error-messages="errors"
            :class="{
              'hide-underline': true,
              'cursor-style': isEdit === false ? true : false,
              'ma-0': true,
            }"
            hide-details="auto"
            v-model="textValue"
            dense
            :readonly="!isEdit"
            @input="$emit('input', textValue)"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </ValidationObserver>
</template>
<script>
import "../util/validationRules";
export default {
  data() {
    return {
      textValue: null,
    };
  },
  props: {
    value: {
      type: String,
    },
    placeholder: String,

    styles: {
      type: String,
    },
    isEdit: {
      type: Boolean,
    },
    validateRules: {
      default: null,
    },
  },
  created() {
    this.textValue = this.value ?? "";
  },

  methods: {
    async checkIsValid() {
      let isValid = await this.$refs.observer.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
.text-red >>> input {
  color: red !important;
}
.cursor-style >>> input {
  cursor: context-menu;
}
</style>
